/* mg-purchase.js  -  MenoGlow: gemeinsame Logik fuer Kauf-Optionen (Abo + Einmalkauf).
   Wird von mehreren Sections genutzt. Kein Markup, keine Tailwind-Klassen hier drin:
   die Section liefert das Markup ueber data-po-Rollen und ein <template data-po="tile">.

   Root-Element:  data-mg-purchase
     data-po-data       id des JSON-Script-Tags (siehe snippets/mg-purchase-data.liquid)
     data-po-locale     Zahlenformat, Default de-DE
     data-po-cta-price  "true" = Preis an die CTA anhaengen
     data-po-cta-sep    Trenner davor, Default " . "
     data-po-pack       "true" = Pack-Referenzpreis (3er Set vs. 1er Set) berechnen
     data-po-plan-desc  "true" = Beschreibung des Verkaufsplans als Notiz nutzen
     data-po-unit-sep   Trenner zwischen Grundpreis-Prefix und Wert, Default " "

   Rollen (data-po="..."):
     pill, grid, wrap, tile(template), price, compare, unit, refnote,
     variant-input, plan-input, qty-input, qty-label, qty-minus, qty-plus, submit, cta
   In der Kachel: dot, name, badge, note, price, compare, unit, vat, packnote
   Aktiv/Inaktiv-Klassen stehen am Element: data-po-base / data-po-on / data-po-off / data-po-disabled
*/
(function () {
  if (window.MGPurchase) return;

  function attr(el, n, d) { var v = el.getAttribute(n); return v === null ? d : v; }
  function q(scope, role) { return scope.querySelector('[data-po="' + role + '"]'); }
  function qa(scope, role) { return Array.prototype.slice.call(scope.querySelectorAll('[data-po="' + role + '"]')); }

  function cls(el, on) {
    var base = attr(el, 'data-po-base', '');
    var stt = attr(el, on ? 'data-po-on' : 'data-po-off', '');
    var dis = el.disabled ? attr(el, 'data-po-disabled', '') : '';
    return (base ? base + ' ' : '') + stt + (dis ? ' ' + dis : '');
  }

  function fillOrDrop(el, txt) {
    if (!el) return;
    if (txt === null || txt === undefined || txt === '') { if (el.parentNode) el.parentNode.removeChild(el); return; }
    el.textContent = txt;
  }

  function leadText(el, txt) {
    if (!el) return;
    if (!el.firstChild || el.firstChild.nodeType !== 3) el.insertBefore(document.createTextNode(''), el.firstChild);
    el.firstChild.nodeValue = txt;
  }

  /* Einrueckung der <template>-Vorlage darf nicht als Textknoten im DOM landen. */
  function stripWs(node) {
    Array.prototype.slice.call(node.childNodes).forEach(function (c) {
      if (c.nodeType === 3) { if (!/\S/.test(c.nodeValue)) node.removeChild(c); }
      else if (c.nodeType === 8) node.removeChild(c);
      else if (c.nodeType === 1) stripWs(c);
    });
  }
  function hide(el, yes) { if (el) el.classList[yes ? 'add' : 'remove']('hidden'); }

  function packSize(t) {
    if (!t) return 1;
    var m = t.match(/(\d+)\s*(?:er|x|\u00d7|stk|pack)/i) || t.match(/^(\d+)\b/);
    var n = m ? parseInt(m[1], 10) : 1;
    return n > 0 ? n : 1;
  }

  function init(root) {
    var src = document.getElementById(attr(root, 'data-po-data', '')) || q(root, 'json');
    if (!src) return;
    var data;
    try { data = JSON.parse(src.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;

    var L = data.labels || {};
    var locale = attr(root, 'data-po-locale', 'de-DE');
    var currency = data.currency || 'EUR';
    var ctaPrice = attr(root, 'data-po-cta-price', 'false') === 'true';
    var ctaSep = attr(root, 'data-po-cta-sep', ' \u00b7 ');
    var usePack = attr(root, 'data-po-pack', 'false') === 'true';
    var useDesc = attr(root, 'data-po-plan-desc', 'false') === 'true';
    var unitSep = attr(root, 'data-po-unit-sep', ' ');

    var pills = qa(root, 'pill');
    var grid = q(root, 'grid');
    var wrap = q(root, 'wrap');
    var tpl = q(root, 'tile');
    var elPrice = q(root, 'price');
    var elCompare = q(root, 'compare');
    var elUnit = q(root, 'unit');
    var elRef = q(root, 'refnote');
    var inVariant = q(root, 'variant-input');
    var inPlan = q(root, 'plan-input');
    var inQty = q(root, 'qty-input');
    var elQty = q(root, 'qty-label');
    var btnMinus = q(root, 'qty-minus');
    var btnPlus = q(root, 'qty-plus');
    var submit = q(root, 'submit');
    var elCta = q(root, 'cta');
    var ctaOrig = elCta ? elCta.textContent : ''; var buyBtn = q(root, 'buynow'); var elBuyCta = q(root, 'buynow-cta'); var buyOrig = elBuyCta ? elBuyCta.textContent : ''; var inReturn = q(root, 'return-input');

    var fmt = function (c) {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(c / 100);
    };

    var single = data.variants.filter(function (v) { return packSize(v.title) === 1; })[0] || data.variants[0];

    function refCompare(v) {
      if (!usePack) return null;
      var ps = packSize(v.title);
      return (ps > 1 && single && v.id !== single.id) ? single.price * ps : null;
    }

    function unitLabel(v, cents) {
      if (!v.unit_price || !v.unit_ref_value) return '';
      var s = (v.unit_price * cents) / v.price;
      var pre = L.unit_price_prefix ? L.unit_price_prefix + unitSep : '';
      return pre + fmt(s) + ' / ' + (v.unit_ref_value === 1 ? '' : v.unit_ref_value + ' ') + v.unit_ref_unit + (L.unit_ref_suffix || '');
    }

    var st = { variant: data.variants[0], plan: null, qty: 1 };

    function tile(o, v, ref) {
      var on = st.plan === o.id;
      var cmp = (ref && (!o.compare || ref > o.compare)) ? ref : o.compare;
      var disc = !!(cmp && o.price < cmp);
      var isRef = disc && cmp === ref;
      var b = tpl.content.firstElementChild.cloneNode(true);
      stripWs(b);
      b.className = cls(b, on);
      var dot = q(b, 'dot');
      if (dot) dot.className = cls(dot, on);
      fillOrDrop(q(b, 'name'), o.name);
      fillOrDrop(q(b, 'badge'), (o.id && disc && L.save_badge) ? L.save_badge : '');
      fillOrDrop(q(b, 'note'), o.note);
      var pEl = q(b, 'price');
      if (pEl) leadText(pEl, fmt(o.price));
      fillOrDrop(q(b, 'compare'), disc ? fmt(cmp) : '');
      fillOrDrop(q(b, 'unit'), unitLabel(v, o.price));
      fillOrDrop(q(b, 'vat'), L.vat || '');
      fillOrDrop(q(b, 'packnote'), isRef ? (L.pack_note || '').replace('{n}', packSize(v.title)) : '');
      b.addEventListener('click', function () { st.plan = o.id; render(); });
      return b;
    }

    function render() {
      pills.forEach(function (b) {
        b.className = cls(b, String(st.variant.id) === b.getAttribute('data-variant'));
      });

      var v = st.variant;
      var ref = refCompare(v);

      var subs = v.plans.map(function (pl) {
        return {
          id: pl.id,
          name: pl.name,
          price: pl.price,
          compare: (pl.compare_at || null),
          note: (useDesc ? (pl.description || L.plan_note || '') : (L.plan_note || ''))
        };
      });
      var once = {
        id: null,
        name: (L.onetime || ''),
        price: v.price,
        compare: (v.compare_at || null),
        note: (L.onetime_note || '')
      };
      var opts = L.subscription_first ? subs.concat([once]) : [once].concat(subs);

      /* Auswahl nur korrigieren, wenn der gewaehlte Plan zur Variante nicht passt.
         Einmalkauf (plan === null) bleibt bewusst erhalten. */
      if (!v.plans.length) st.plan = null;
      else if (st.plan !== null && !v.plans.some(function (x) { return x.id === st.plan; })) st.plan = v.plans[0].id;

      var showWrap = v.plans.length ? true : ((L.single_option || 'show') === 'show');
      if (wrap) hide(wrap, !showWrap);
      if (!showWrap) st.plan = null;
      if (grid) {
        grid.innerHTML = '';
        if (showWrap && tpl) opts.forEach(function (o) { grid.appendChild(tile(o, v, ref)); });
      }

      var sel;
      if (st.plan === null) sel = { price: v.price, compare: (v.compare_at || null) };
      else {
        var pl = v.plans.filter(function (x) { return x.id === st.plan; })[0];
        sel = pl ? { price: pl.price, compare: (pl.compare_at || null) } : { price: v.price, compare: null };
      }
      var scmp = (ref && (!sel.compare || ref > sel.compare)) ? ref : sel.compare;
      var showCmp = !!(scmp && scmp > sel.price);

      if (elPrice) leadText(elPrice, fmt(sel.price));
      if (elCompare) {
        if (showCmp) elCompare.textContent = fmt(scmp);
        hide(elCompare, !showCmp);
      }
      if (elRef) {
        var isRefSel = showCmp && scmp === ref;
        if (isRefSel) elRef.textContent = (L.ref_note || '').replace('{n}', packSize(v.title));
        hide(elRef, !isRefSel);
      }
      if (elUnit) elUnit.textContent = unitLabel(v, sel.price);

      if (inVariant) inVariant.value = v.id;
      if (inPlan) inPlan.value = st.plan === null ? '' : st.plan;
      if (inQty) inQty.value = st.qty;
      if (elQty) elQty.textContent = st.qty;

      if (submit) submit.disabled = (v.available === false);
      if (elCta) {
        if (v.available === false) elCta.textContent = (L.sold_out || ctaOrig);
        else elCta.textContent = ctaPrice ? ((L.cta || ctaOrig) + ctaSep + fmt(sel.price)) : (L.cta || ctaOrig); } if (buyBtn) buyBtn.disabled = (v.available === false); if (elBuyCta) { if (v.available === false) elBuyCta.textContent = (L.sold_out || buyOrig); else elBuyCta.textContent = ctaPrice ? ((L.buy_now || buyOrig) + ctaSep + fmt(sel.price)) : (L.buy_now || buyOrig);
      }
    }

    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = data.variants.filter(function (v) { return String(v.id) === b.getAttribute('data-variant'); })[0];
        if (f) { st.variant = f; render(); }
      });
    });
    if (btnMinus) btnMinus.addEventListener('click', function () { st.qty = Math.max(1, st.qty - 1); render(); });
    if (btnPlus) btnPlus.addEventListener('click', function () { st.qty = st.qty + 1; render(); }); if (buyBtn) buyBtn.addEventListener('click', function () { if (inReturn) inReturn.value = '/checkout'; }); if (submit) submit.addEventListener('click', function () { if (inReturn) inReturn.value = ''; });

    /* Startauswahl: einmalig, nicht in render() - sonst laesst sich Einmalkauf nie waehlen. */
    /* Einmalkauf ist beim initialen Laden vorausgewaehlt (st.plan bleibt null); subscription_first steuert nur noch die Kachel-Reihenfolge. */
    render();
  }

  function scan(scope) {
    var nodes = (scope || document).querySelectorAll('[data-mg-purchase]');
    Array.prototype.forEach.call(nodes, function (r) {
      if (r.__mgPurchase) return;
      r.__mgPurchase = true;
      try { init(r); } catch (e) { if (window.console) console.warn('mg-purchase:', e); }
    });
  }

  window.MGPurchase = { init: init, scan: scan, packSize: packSize, version: '1.0' };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target || document); });
})();
